// @flow
import ResourceModel from "../base/ResourceModel";

import ModelCategoryCollection from "./ModelCategoryCollection";

import { IllegalStateException } from "../../exceptions";

import type LinkModel from "../links/LinkModel";

/**
 * The Application model
 */
export default class ModelCatalogModel extends ResourceModel {
  /**
   */
  get type(): string {
    return "ModelCatalog";
  }

  /**
   */
  static get modelName(): string {
    return "ModelCatalogModel";
  }

  /**
   */
  static isApplicableModel(data: Object): boolean {
    return (
      data.contributions.resourcetype &&
      data.contributions.resourcetype === "ModelCatalog"
    );
  }

  /**
   */
  get label(): string {
    return this.locale === "nl" ? "Model catalogus" : "Model catalog";
  }

  /**
   * Retrieve link to Concept Index model
   */
  get conceptIndexLink(): LinkModel {
    const link = this.links.getLinkByKey("concepts");
    if (!link) {
      throw new IllegalStateException(
        "Missing concepts index link in model catalog",
      );
    }
    return link;
  }

  /**
   * Retrieve link to Content Index model
   */
  get contentIndexLink(): LinkModel {
    const link = this.links.getLinkByKey("content");
    if (!link) {
      throw new IllegalStateException(
        "Missing content index link in model catalog",
      );
    }
    return link;
  }

  /**
   * Retrieve model categories as a collection
   */
  get modelcategories(): ModelCategoryCollection {
    return new ModelCategoryCollection(this.data.modelcategories);
  }
}
